export default __webpack_public_path__ + "static/media/virtual-tour-slide-3-mobile.94e5bc04.png";